import React from 'react';
import IntroSection from '../../../component/introSection';
import { MainBgWrapper } from '../../../component/bgWrapper';
import PasswordChangeInput from './component/passwordChangeInput';

const PasswordChange:React.FC = () => (
  <MainBgWrapper>
    <IntroSection title="[비밀번호변경]" content="회원님의 소중한 정보를 보호하기 위해 비밀번호 변경 후 서비스를 이용해 주세요" />
    <PasswordChangeInput />
  </MainBgWrapper>
);

export default PasswordChange;
